import App from './App.svelte';

let targets = document.getElementsByTagName("yearly-magnetograms");

for(let i = 0;i < targets.length; i++){
    let target = targets[i];
    const app_instance = new App({
    target: target,
    props: {
    }
  });
}
